// extracted by mini-css-extract-plugin
export default {"button":"M0RBM","expand":"ZIWYG","suffixIcon":"KvYWY","colorFromFullButton":"DpKyF","colorFromHollowButton":"eor+S"};